import hooks from './shipment-requests.hooks';
import createSchema from './shipment-requests.schema';

export default (app) => {
  const service = app.service('api/shipment-requests');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
